import React, { useState } from "react";
import { X } from "lucide-react";

const KEY = "plyx_cyberguard_banner_dismissed";

// Plyx Cyber Guard launch banner — shown on all non-feed surfaces.
// Dismiss persists per-browser via localStorage.
export default function CyberGuardBanner() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  if (hidden) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div
      className="relative bg-[#050505] text-[#F4F4F5] border-b border-[#1A2E1E]"
      style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
      data-testid="cyberguard-banner"
    >
      <a
        href="https://plyxcyberguard.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="cyberguard-banner-link"
        className="flex items-center justify-center gap-2.5 px-10 py-3 text-[13px] leading-snug hover:bg-[#0B0B0B] transition-colors"
      >
        <span className="text-[#00FF41] font-bold whitespace-nowrap">● NEW</span>
        <span className="hidden sm:inline">
          We just launched <b>Plyx Cyber Guard</b> — AI protection from phishing &amp; malicious links.
        </span>
        <span className="sm:hidden"><b>Plyx Cyber Guard</b> — AI phishing protection</span>
        <span className="text-[#00FF41] font-bold border border-[#00FF41] px-2.5 py-1 whitespace-nowrap text-[12px]">
          Try it free →
        </span>
      </a>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss announcement"
        data-testid="cyberguard-banner-dismiss"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#F4F4F5]/60 hover:text-white transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
